import ExternalCreditApplicationSchemas from './external_credit_applications/external_credit_applications';

import CoSignerRequestsSchemas from './co_signer_requests/co_signer_requests';

export const allSchemas = {
  ...CoSignerRequestsSchemas,

  ...ExternalCreditApplicationSchemas,
};
